
// 权限检查方法
export default function processTree (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].children.length < 1) {
      // children长度小于1, 将children置为null
      data[i].children = null
    } else {
      // 否则继续进入循环
      processTree(data[i].children)
    }
  }
  // 最后处理完的数据
  return data
}



// WEBPACK FOOTER //
// ./src/utils/processTree.js